let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gkvZi")).then(() => parcelRequire('cLRZa'));